export enum FulfillmentColumns {
  pharmacy,
  productName,
  ndc,
  daysSupply,
  shipDate
}
